module.exports = __webpack_public_path__ + "img/icon-24-ic-close.ceb2ce06.svg";